import script from "./NewsDetailPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewsDetailPage.vue?vue&type=script&lang=ts&setup=true"

import "./NewsDetailPage.vue?vue&type=style&index=0&id=020223d8&scoped=true&lang=less"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020223d8"]])

export default __exports__